import React from 'react';
import { createMuiTheme, MuiThemeProvider as MUIThemeProvider } from '@material-ui/core/styles';
import { Colors } from '@origin-digital/style-guide';

/**
 * This is added specifically for styling the tooltip (inside ExpandedRates) which is current a straight MUI component.
 * This can be removed once ODS-CORE publishes its Tooltip component and we replace the MUI ones with it.
 */
const theme = createMuiTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: '14px',
        color: Colors.GREY,
        backgroundColor: Colors.WHITE,
        border: 'solid 1px #ddd',
        boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.16)',
        fontFamily: 'gordita, sans-serif, -apple-system, BlinkMacSystemFont',
        padding: '16px',
      },
      arrow: {
        color: Colors.WHITE,
      },
      popper: {
        height: 'auto !important',
      },
    },
    MuiIconButton: {
      root: {
        '&: hover': {
          backgroundColor: 'none',
        },
      },
    },
  },
});

export const MuiThemeProvider = ({ children }) => (
  <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>
);
